import {gql} from '@apollo/client';

// SUPERADMIN-only catalog management. Editing the catalog changes which
// tabs / sub-tabs become grantable in the role builder. There is no `order`
// or `isActive` field — deletes are hard deletes.

export const UPSERT_ADMIN_DASHBOARD_MENU_TAB = gql`
  mutation UpsertAdminDashboardMenuTab(
    $data: UpsertAdminDashboardMenuTabInput!
  ) {
    upsertAdminDashboardMenuTab(data: $data) {
      ... on Error {
        message
        statusCode
      }
      ... on ResponseWithAdminDashboardMenuTab {
        message
        data {
          id
          key
          label
          subTabs {
            key
            label
          }
        }
      }
    }
  }
`;

export const UPSERT_ADMIN_DASHBOARD_MENU_SUBTAB = gql`
  mutation UpsertAdminDashboardMenuSubTab(
    $data: UpsertAdminDashboardMenuSubTabInput!
  ) {
    upsertAdminDashboardMenuSubTab(data: $data) {
      ... on Error {
        message
        statusCode
      }
      ... on ResponseWithAdminDashboardMenuTab {
        message
        data {
          id
          key
          label
          subTabs {
            key
            label
          }
        }
      }
    }
  }
`;

export const DELETE_ADMIN_DASHBOARD_MENU_TAB = gql`
  mutation DeleteAdminDashboardMenuTab($key: String!) {
    deleteAdminDashboardMenuTab(key: $key) {
      ... on Error {
        message
        statusCode
      }
      ... on ResponseWithAdminDashboardMenuTab {
        message
      }
    }
  }
`;

export const DELETE_ADMIN_DASHBOARD_MENU_SUBTAB = gql`
  mutation DeleteAdminDashboardMenuSubTab(
    $tabKey: String!
    $subTabKey: String!
  ) {
    deleteAdminDashboardMenuSubTab(tabKey: $tabKey, subTabKey: $subTabKey) {
      ... on Error {
        message
        statusCode
      }
      ... on ResponseWithAdminDashboardMenuTab {
        message
      }
    }
  }
`;
